import * as L from 'leaflet';

export interface MapEvent<T> {
  type: MapEventType;
  data: T;
}

export enum MapEventType {
  CENTER_ON_MAP,
  CENTER_ELEMENT_ON_MAP,
  ENLARGE_ON_MAP,
  ENABLE_DRAW_POLYGON,
  DISABLE_DRAW_POLYGON,
  CLEAR_POLYGON,
  SELECTED_POLYGON,
  ENABLE_DRAW_RECT,
  DISABLE_DRAW_RECT,
  CLEAR_RECT,
  SELECTED_RECT,
  ENABLE_DRAW_CIRCLE,
  DISABLE_DRAW_CIRCLE,
  SELECTED_CIRCLE,
  CLEAR_CIRCLE
}

export interface CenterOnMap {
  latLng: L.LatLng;
  zoom: number;
}

export interface EnlargeOnMap<T> {
  dataType: string;
  data: T;
  timeMillis: number;
  // Czy wolno ruszyć widokiem, żeby wydobyć marker z klastra. Przy wielu wskazanych pojazdach musi być
  // false - kadr jest wtedy ustawiony raz na wszystkie (fitLayerMarkersForKeys) i nie wolno go przestawiać.
  revealClustered: boolean;
}
